import { Box, Button, Dialog } from "@mui/material"
import CloseModalButton from "../../../../components/CloseModalButton"
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from "../../../../components/Dialog.styled"
import { Autoclave } from "../types"
import { getAutoclaves, deleteAutoclave } from "../../../../services/biologicalServices"
import { Dispatch, SetStateAction, useState } from "react"
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import { addError, addSuccess } from "../../../../redux/alerts"
import { useAppDispatch } from "../../../../redux/store"

type AutoclaveDeleteModal = {
  open: boolean,
  autoclave: Autoclave,
  customerNumber: string,
  handleClose: () => void,
  setAutoclaves: Dispatch<SetStateAction<Autoclave[]>>,
}

const AutoclaveDeleteModal = (props: AutoclaveDeleteModal) => {
  const {
    open,
    autoclave,
    customerNumber,
    setAutoclaves,
    handleClose,
  } = props

  const [isUpdating, setIsUpdating] = useState<boolean>(false)

  const dispatch = useAppDispatch()

  const handleDelete = async () => {
    try {
      setIsUpdating(true)    

      await deleteAutoclave(customerNumber, autoclave.autoclave_id)

      const autoclaveData = await getAutoclaves(customerNumber)

      setIsUpdating(false)
      setAutoclaves(autoclaveData)

      handleClose()
      dispatch(addSuccess(`${autoclave.autoclave_name} deleted`))
    } catch (err) {
      console.error(err)
      setIsUpdating(false)
      dispatch(addError(err instanceof Error ? err.message : 'There was a problem deleting the autoclave'))
      handleClose()
    }
  }

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <CloseModalButton handleClose={handleClose} />
        <StyledDialogTitle>
          <Box className="flex flex-align-center">
            <DeleteForeverIcon />
            Delete Autoclave
          </Box>
        </StyledDialogTitle>
        <StyledDialogContent>
          Are you sure you want to delete {autoclave.autoclave_name}?
        </StyledDialogContent>
        <StyledDialogFooter>
          <Button variant="outlined" onClick={handleClose}>
            No
          </Button>
          <Button variant="contained" onClick={handleDelete} disabled={isUpdating}>
            Yes
          </Button>
        </StyledDialogFooter>
      </Dialog>
    </>
  )
}

export default AutoclaveDeleteModal
